<div class="info-snippet-container">
  <div class="usp-img-container">
    <!--    <app-asset [model]="model.image" class="zm-icon" alt=""></app-asset>-->
    <img [src]="stepItem.image" />
  </div>
  <div class="usp-text-container">
    <div class="usp-title-text">{{ stepItem.stepNumber }}. {{ stepItem.heading }}</div>
    <div class="usp-text">{{ stepItem.subText }}</div>
  </div>
</div>
